import { styled } from '../../../stitches.config';

import { ContentWrapper, ContentSpacer } from '../Content/Content';

const Logo = styled('img', {});
const LogoText = styled('span', {
  fontSize: '$4',
  fontWeight: 100,
});

const Content = styled('header', {
  display: 'flex',
  alignItems: 'center',
  gap: '$5',
  height: '5rem',
  margin: '$5 0',
  listStyle: 'none',
});

export interface HeaderProps {
  logoSrc: string;
  logoAlt?: string;
  logoSize?: number;
  text: string;
}

export function Header(props: HeaderProps) {
  const { logoSrc, logoAlt = 'Molecule.one', logoSize = 200, text } = props;

  return (
    <ContentWrapper>
      <ContentSpacer>
        <Content>
          <Logo src={logoSrc} alt={logoAlt} width={logoSize} />
          <LogoText>{text}</LogoText>
        </Content>
      </ContentSpacer>
    </ContentWrapper>
  );
}
